import Vue from 'vue'
import App from './App.vue'
import router from './router'
Vue.config.productionTip = false


import VueAwesomeSwiper from "vue-awesome-swiper"
// 引入swiper样式
import "swiper/dist/css/swiper.css";
//挂载swiper
Vue.use(VueAwesomeSwiper);

new Vue({
  router,
  render: h => h(App),
}).$mount('#app')
